import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TokenService } from '@core/services/token.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrgInterceptorService implements HttpInterceptor {

    constructor(private readonly tokenService: TokenService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const tenant: string | null = this.tokenService.getTenant();

        if(tenant !== null) {
            
            request = request.clone({
                setHeaders: {
                "x-requestor": tenant
                }
            });
        }

        return next.handle(request);
    }
}
